
import { ElForm, ElMessage, ElMessageBox, ElLoading } from 'element-plus'
import { defineComponent, reactive, toRefs, onMounted, ref } from 'vue'
import Container from '@/components/form/container/Container.vue'
import SearchForm from '@/components/form/search/SearchForm.vue'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import CenterForm from '@/components/form/common/CenterForm.vue'
import NomalContainer from '@/components/dfms-components/container/NomalContainer.vue'
import UploadFormItem from '@/components/form/common/UploadFormItem.vue'
import {
  LabelFrameModel,
  LabelFramePageSearchModel,
  LabelFrameSearchModel,
  LabelFrameAddModel,
  LabelFrameUpdateModel,
  IdsModel
} from '@/model/product/LabelFrameModel'
import {
  pageSearchLabelFrame,
  addLabelFrame,
  updateLabelFrame,
  removeLabelFrame,
  batchRemoveLabelFrame
} from '@/apis/product/labelFrame'
import { LabelFrameCategorySearchModel } from '@/model/product/LabelFrameCategoryModel'
import { searchLabelFrameCategory } from '@/apis/product/labelFrameCategory'
import { parseTime } from '@/utils'
import { createModel } from '@/utils/component'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  components: {
    Container,
    SearchForm,
    SimpleTable,
    CenterForm,
    UploadFormItem,
    NomalContainer
  },
  setup() {
    const { t } = useI18n()
    const searchFormRef = ref(ElForm)
    const leftImageUrlRef = ref()
    const rightImageUrlRef = ref()
    const frameThumbnailRef = ref()
    const searchStruct = [
      {
        prop: 'categoryId',
        label: t('labelFrame.categoryId'),
        placeholder: t('labelFrame.categoryIdP'),
        component: 'el-select',
        model: '',
        filterable: true,
        remote: true,
        loading: false,
        remoteMethod: async(query: string) => { console.log(query) },
        options: [] as any
      }
    ]

    const createStruct = [
      // { prop: 'leftImageUrl', label: t('labelFrame.leftImageUrl'), placeholder: t('labelFrame.leftImageUrlP'), component: 'el-input', type: 'text', model: null },
      // { prop: 'rightImageUrl', label: t('labelFrame.rightImageUrl'), placeholder: t('labelFrame.rightImageUrlP'), component: 'el-input', type: 'text', model: null },
      // { prop: 'frameThumbnail', label: t('labelFrame.frameThumbnail'), placeholder: t('labelFrame.frameThumbnailP'), component: 'el-input', type: 'text', model: null },
      {
        prop: 'categoryId',
        label: t('labelFrame.categoryId'),
        placeholder: t('labelFrame.categoryIdP'),
        component: 'el-select',
        model: '',
        filterable: true,
        remote: true,
        loading: false,
        remoteMethod: async(query: string) => { console.log(query) },
        options: [] as any
      }
    ]

    const updateStruct = [
      // { prop: 'leftImageUrl', label: t('labelFrame.leftImageUrl'), placeholder: t('labelFrame.leftImageUrlP'), component: 'el-input', type: 'text', model: null },
      // { prop: 'rightImageUrl', label: t('labelFrame.rightImageUrl'), placeholder: t('labelFrame.rightImageUrlP'), component: 'el-input', type: 'text', model: null },
      // { prop: 'frameThumbnail', label: t('labelFrame.frameThumbnail'), placeholder: t('labelFrame.frameThumbnailP'), component: 'el-input', type: 'text', model: null },
      {
        prop: 'categoryId',
        label: t('labelFrame.categoryId'),
        placeholder: t('labelFrame.categoryIdP'),
        component: 'el-select',
        model: '',
        filterable: true,
        remote: true,
        loading: false,
        remoteMethod: async(query: string) => { console.log(query) },
        options: [] as any
      }
    ]

    const labelFrameRole = {
      leftImageUrl: [{ required: true, message: t('labelFrame.leftImageUrl').concat(t('common.isRequired')), trigger: 'blur' }],
      rightImageUrl: [{ required: true, message: t('labelFrame.rightImageUrl').concat(t('common.isRequired')), trigger: 'blur' }],
      frameThumbnail: [{ required: true, message: t('labelFrame.frameThumbnail').concat(t('common.isRequired')), trigger: 'blur' }],
      categoryId: [{ required: true, message: t('labelFrame.categoryId').concat(t('common.isRequired')), trigger: 'blur' }]
    }

    const tableStruct = [

      { prop: 'leftImageUrl', label: t('labelFrame.leftImageUrl'), sortable: 'custom', link: true },
      { prop: 'rightImageUrl', label: t('labelFrame.rightImageUrl'), sortable: 'custom', link: true },
      { prop: 'frameThumbnail', label: t('labelFrame.frameThumbnail'), sortable: 'custom', img: 'frameThumbnail' },
      { prop: 'categoryName', label: t('labelFrame.categoryId'), sortable: 'custom' },
      { prop: 'createTime', label: t('common.createTime'), formatter: (row: LabelFrameModel) => { return parseTime(row.createTime) }, sortable: 'custom' },
      { prop: 'updateTime', label: t('common.updateTime'), formatter: (row: LabelFrameModel) => { return parseTime(row.updateTime) }, sortable: 'custom' }
    ]
    const dataMap = reactive({
      searchFormStruct: searchStruct,
      searchFormModel: createModel(searchStruct) as LabelFrameSearchModel,
      tableData: Array<LabelFrameModel>(),
      columnStruct: tableStruct,
      listLoading: true,
      selection: Array<number>(),
      limit: 10,
      total: 0,
      page: 1,
      sort: 'createTime',
      order: 'desc',
      dialogStatus: 'create',
      textMap: {
        update: 'labelFrame.edit',
        create: 'labelFrame.create'
      },
      dialogFormVisible: false,
      labelFrameRole: labelFrameRole,
      createStruct: createStruct,
      createModel: createModel(createStruct) as LabelFrameAddModel,
      updateStruct: updateStruct,
      updateModel: createModel(updateStruct) as LabelFrameUpdateModel,
      editRow: {} as LabelFrameModel,
      handleSelection(item: any[]) {
        dataMap.selection = item
      },
      handleCurrentChange(page?: any) {
        dataMap.page = page
        dataMap.getList()
      },
      handleSizeChange(val: any) {
        dataMap.limit = val
        dataMap.getList()
      },
      handleOrder(column: any) {
        dataMap.sort = column.prop
        dataMap.order = column.order === 'descending' ? 'desc' : 'asc'
        dataMap.getList()
      },
      async getList() {
        dataMap.listLoading = true
        const params: LabelFramePageSearchModel = {
          leftImageUrl: dataMap.searchFormModel.leftImageUrl,
          rightImageUrl: dataMap.searchFormModel.rightImageUrl,
          frameThumbnail: dataMap.searchFormModel.frameThumbnail,
          categoryId: dataMap.searchFormModel.categoryId,
          page: dataMap.page,
          limit: dataMap.limit,
          sort: dataMap.sort,
          order: dataMap.order
        }
        const data = await pageSearchLabelFrame(params)
        dataMap.tableData = data?.data?.records ?? []
        const total = data?.data?.total ?? '0'
        dataMap.total = parseInt(total)

        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      },
      submitSearch() {
        dataMap.page = 1
        dataMap.getList()
      },
      resetForm() {
        console.log('reset')
      },
      uploadReset() {
        console.log('upload reset')
        if (leftImageUrlRef.value) {
          leftImageUrlRef.value.onReset()
        }
        if (rightImageUrlRef.value) {
          rightImageUrlRef.value.onReset()
        }
        if (frameThumbnailRef.value) {
          frameThumbnailRef.value.onReset()
        }
        dataMap.createModel.leftImageUrl = null
        dataMap.createModel.rightImageUrl = null
        dataMap.createModel.frameThumbnail = null
      },
      leftImageUrlChange(file: any) {
        dataMap.createModel.leftImageUrl = file
      },
      rightImageUrlChange(file: any) {
        dataMap.createModel.rightImageUrl = file
      },
      frameThumbnailChange(file: any) {
        dataMap.createModel.frameThumbnail = file
      },
      async createSubmit() {
        const params = new FormData()
        params.append('categoryId', dataMap.createModel.categoryId.toString())
        params.append('leftImageUrl', dataMap.createModel.leftImageUrl.raw)
        params.append('rightImageUrl', dataMap.createModel.rightImageUrl.raw)
        params.append('frameThumbnail', dataMap.createModel.frameThumbnail.raw)
        const loading = ElLoading.service({
          lock: true,
          text: t('common.uploading'),
          background: 'rgba(0, 0, 0, 0.7)'
        })
        const result = await addLabelFrame(params)
        loading.close()
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.status) {
          ElMessage({
            message: t('common.createSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.statusText,
            type: 'error',
            duration: 2000
          })
        }
      },
      async updateNameSubmit() {
        const updateData: LabelFrameUpdateModel = {
          id: dataMap.updateModel.id,
          leftImageUrl: dataMap.updateModel.leftImageUrl,
          rightImageUrl: dataMap.updateModel.rightImageUrl,
          frameThumbnail: dataMap.updateModel.frameThumbnail,
          categoryId: dataMap.updateModel.categoryId
        }
        const result = await updateLabelFrame(updateData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.updateSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async deleteData(id: number) {
        const result = await removeLabelFrame(id)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async bathDeleteData() {
        const deleteData: IdsModel = { ids: dataMap.selection }
        const result = await batchRemoveLabelFrame(deleteData)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      updateNameReset() {
        console.log('update reset')
        dataMap.updateModel.id = dataMap.editRow.id
        dataMap.updateModel.leftImageUrl = dataMap.editRow.leftImageUrl
        dataMap.updateModel.rightImageUrl = dataMap.editRow.rightImageUrl
        dataMap.updateModel.frameThumbnail = dataMap.editRow.frameThumbnail
        dataMap.updateModel.categoryId = dataMap.editRow.categoryId
      },
      createReset() {
        console.log('create reset')
        dataMap.uploadReset()
      }
    })
    const getLabelFrameCategoryOptions = async(query: string) => {
      if (dataMap.dialogFormVisible) {
        if (dataMap.dialogStatus === 'create') {
          dataMap.createStruct[0].loading = true
        } else if (dataMap.dialogStatus === 'update') {
          dataMap.updateStruct[0].loading = true
        }
      } else {
        dataMap.searchFormStruct[0].loading = true
      }
      const params: LabelFrameCategorySearchModel = {
        categoryName: query,
        categoryOrder: null
      }
      const data = await searchLabelFrameCategory(params)
      const list = data?.data ?? []
      const optionList = []
      for (const iterator of list) {
        optionList.push({ label: iterator.categoryName, value: iterator.id })
      }
      if (dataMap.dialogFormVisible) {
        if (dataMap.dialogStatus === 'create') {
          dataMap.createStruct[0].options = optionList
        } else if (dataMap.dialogStatus === 'update') {
          dataMap.updateStruct[0].options = optionList
        }
      } else {
        dataMap.searchFormStruct[0].options = optionList
      }
      dataMap.createStruct[0].loading = false
      dataMap.updateStruct[0].loading = false
      dataMap.searchFormStruct[0].loading = false
    }
    const handleCreate = () => {
      dataMap.uploadReset()
      dataMap.dialogStatus = 'create'
      getLabelFrameCategoryOptions('')
      dataMap.dialogFormVisible = true
    }
    const handleEdit = (row?: LabelFrameModel) => {
      if (row) {
        dataMap.editRow = row
        dataMap.dialogStatus = 'update'
        dataMap.updateModel.id = row.id
        dataMap.updateModel.leftImageUrl = row.leftImageUrl
        dataMap.updateModel.rightImageUrl = row.rightImageUrl
        dataMap.updateModel.frameThumbnail = row.frameThumbnail
        dataMap.updateModel.categoryId = row.categoryId
        getLabelFrameCategoryOptions('')
        dataMap.dialogFormVisible = true
      }
    }
    const handleDelete = (id: number) => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.deleteData(id)
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    const handleBathDelete = () => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.bathDeleteData()
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    onMounted(() => {
      dataMap.searchFormStruct[0].remoteMethod = getLabelFrameCategoryOptions
      dataMap.createStruct[0].remoteMethod = getLabelFrameCategoryOptions
      dataMap.updateStruct[0].remoteMethod = getLabelFrameCategoryOptions
      getLabelFrameCategoryOptions('')
      dataMap.getList()
    })
    return {
      t,
      handleCreate,
      handleEdit,
      handleDelete,
      handleBathDelete,
      searchFormRef,
      leftImageUrlRef,
      rightImageUrlRef,
      frameThumbnailRef,
      ...toRefs(dataMap)
    }
  }
})
